import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import * as S from './styled';

// Close icon component
const CloseIcon = () => (
  <svg width="24" height="24" viewBox="0 0 24 24" fill="currentColor">
    <path d="M19 6.41L17.59 5 12 10.59 6.41 5 5 6.41 10.59 12 5 17.59 6.41 19 12 13.41 17.59 19 19 17.59 13.41 12z"/>
  </svg>
);

/**
 * Expanded Modal - Floating Chat Widget Container for WebRTC Component
 * 
 * Features:
 * - Desktop: Dropdown positioning from top-right
 * - Mobile: Full-screen modal
 * - Contains existing WebRTC component with no modifications
 * - Allows page interaction while chatting (no backdrop blocking)
 * - Only closes via close button or escape key
 */
const ExpandedModal = ({ children, onClose }) => {
  
  // Handle escape key
  useEffect(() => {
    const handleEscape = (event) => {
      if (event.key === 'Escape') {
        onClose();
      }
    };

    document.addEventListener('keydown', handleEscape);
    
    return () => {
      document.removeEventListener('keydown', handleEscape);
    };
  }, [onClose]);

  return (
    <S.ModalOverlay>
      <S.ModalContainer>
        <S.ModalHeader>
          <S.ModalTitle>Ask Dasha</S.ModalTitle>
          <S.CloseButton 
            onClick={onClose}
            aria-label="Close conversation"
          >
            <CloseIcon />
          </S.CloseButton>
        </S.ModalHeader>
        
        <S.ModalContent>
          {children}
        </S.ModalContent>
      </S.ModalContainer>
    </S.ModalOverlay>
  );
};

ExpandedModal.propTypes = {
  children: PropTypes.node.isRequired,
  onClose: PropTypes.func.isRequired
};

export default ExpandedModal;